import { MoleMeta } from 'views/VvsMinerMoleMyMoles/types'

import { INFO_API_ENDPOINT, GET_MOLE, GET_MOLES } from './endpointPaths'

export const fetchMole = async (id: string): Promise<MoleMeta> => {
  const res = await fetch(`${INFO_API_ENDPOINT}/${GET_MOLE}/${id}`)
  return res.json()
}

export const fetchMoles = async (ids: string[]): Promise<MoleMeta[]> => {
  if (!ids || ids.length <= 0) return []
  const queryIdsString = ids.map((id) => `id=${id}`).join('&')
  const res = await fetch(`${INFO_API_ENDPOINT}/${GET_MOLES}?${queryIdsString}`)
  return res.json()
}
